import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Container,
  Card,
  CardImg,
  CardBody,
  CardTitle,
} from "shards-react";
import styled from "styled-components";
import { Link as RouteNavLink } from "react-router-dom";
import Bg_Indicators from "shared/assets/img/bg_inlist.png";
import box_in44 from "shared/assets/img/box_in44.png";
import box_in4 from "shared/assets/img/box_in4.png";
import box_in1 from "shared/assets/img/box_in1.png";
import box_in7 from "shared/assets/img/box_in7.png";
import baseUrl from "config/baseUrl";
import { useTranslation } from "react-i18next";

const axios = require("axios").default;

const IndicatorsContent = styled.div`
  background-image: url(${Bg_Indicators});
  margin-left: -15px;
  margin-right: -15px;
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
`;
const Link = styled.a`
  position: absolute;
  right: 0;
  top: 25;
`;

const StyledCard = styled(Card)`
  background-color: #1968bc;
  padding: 20px;
  height: 100%;
`;
const StyledCardImg = styled(CardImg)`
  border-radius: unset;
  height: 130px;
`;
const StyledTitle = styled(CardTitle)`
  color: #fff;
  font-size: 16px;
  text-align: center;
`;
const StyledCardBody = styled(CardBody)`
  padding: 20px 0 0 0;
`;
const StyledContainer = styled.div`
  background: linear-gradient(
    0deg,
    rgb(255 255 255 / 0%) -100%,
    rgb(0 0 0 / 100%) 100%
  );
  padding: 30px;
`;

const Indicators = (props) => {
  const [dataindicatorsDataset, setDataindicatorsDataset] = useState(null);
  const { t, i18n } = useTranslation();
  // useEffect(() => {
  //   var data = JSON.stringify({
  //     params: {
  //       id: "",
  //     },
  //     show: 1000,
  //     page: 1,
  //     orderBy: "id",
  //     orderType: "ASC",
  //   });

  //   var config = {
  //     method: "post",
  //     url: `${baseUrl}/v1/setting/indicatorsDataset`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };
  //   axios(config)
  //     .then((response) => {
  //       setDataindicatorsDataset(response.data);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }, []);

  useEffect(() => {
    var data = JSON.stringify({
      params: {
        interestingSettingId: "",
      },
      show: 5,
      page: 1,
      orderBy: "interestingSettingId",
      orderType: "ASC",
    });

    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/interestingsettinglist`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then((response) => {
        //   setBannerSettingData(response.data);
        setDataindicatorsDataset(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  // useEffect(() => {
  //   if (token) {
  //     var data = JSON.stringify({
  //       params: {
  //         interestingSettingId: "",
  //       },
  //       show: 5,
  //       page: 1,
  //       orderBy: "interestingSettingId",
  //       orderType: "ASC",
  //     });

  //     var config = {
  //       method: "post",
  //       url: `${baseUrl}/v1/setting/interestingsettinglist`,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //       data: data,
  //     };
  //     axios(config)
  //       .then((response) => {
  //         //   setBannerSettingData(response.data);
  //         setInterestingListData(response.data);
  //       })
  //       .catch((error) => {
  //         console.log(error);
  //       });
  //   }
  // }, [openModalCreateInteresting, openModalDeleteInteresting]);

  const getImage = (number) => {
    switch (number) {
      case 0:
        return box_in44;
      case 1:
        return box_in4;
      case 2:
        return box_in1;
      case 3:
        return box_in7;
      default:
        return box_in44;
    }
  };
  const checkShow = [6, 9, 12, 44];
  return (
    <IndicatorsContent>
      <StyledContainer>
        <Container>
          <Row>
            <Col className="text-center">
              <h5 className="bold text-white">
                - {t("common:homePage.InterestingKPI")} -
              </h5>
              <Link className="text-white" href="/indicators-list">{`${t(
                "common:homePage.TotalInformationKPI"
              )} >>`}</Link>
            </Col>
          </Row>
          <Row style={{ padding: "50px 0" }}>
            {dataindicatorsDataset != null &&
            dataindicatorsDataset.data.length > 0 ? (
              dataindicatorsDataset.data.map((item, key) => {
                return (
                  <Col
                    tag={RouteNavLink}
                    to={`/indicators/detail/${item.indicatorsDatasetSettingId}`}
                    sm="6"
                    md="4"
                    xl="3"
                    key={key}
                  >
                    <StyledCard>
                      <StyledCardImg
                        top
                        src={`${baseUrl}/${item.interestingSettingPic}`}
                      />
                      <StyledCardBody>
                        <StyledTitle className="mb-0">
                          {i18n.language === "th"
                            ? item.interestingSettingName
                            : item.interestingSettingNameEN || item.interestingSettingName}
                        </StyledTitle>
                      </StyledCardBody>
                    </StyledCard>
                  </Col>
                );
              })
            ) : (
              <Col md="12" className="text-center">
                --- {t("common:homePage.NoData")} ---
              </Col>
            )}
          </Row>
        </Container>
      </StyledContainer>
    </IndicatorsContent>
  );
};
export default Indicators;
